/* eslint-env browser */

'use strict';

import React from 'react';
import ReactDOM from 'react-dom';
import AppProvider from './AppProvider.react';

ReactDOM.render(<AppProvider />, document.getElementById('react-entry-point'));
